import { Alert, Box, Grid, Typography } from '@mui/material';
import { neutral } from '~/styles/tokens/primitives.colors';
import { contractUploadAppId } from '../contractAppIds';
import type { ContractUploadFieldDef } from '../getContractUploadFields';
import type { TypeFile } from '../../step4/hooks/types';
import type { IFile } from '~/services/modules/contract/types';
import ContractJourneyFileUpload from './ContractJourneyFileUpload';

type ContractUploadSectionProps = {
  fields: ContractUploadFieldDef[];
  files: Partial<Record<TypeFile, IFile | null>>;
  errors: Partial<Record<TypeFile, boolean>>;
  voucher?: string;
  showVoucherHint?: boolean;
  onChangeFile: (key: TypeFile, file: IFile) => void;
};

export default function ContractUploadSection({
  fields,
  files: _files,
  errors,
  voucher,
  showVoucherHint,
  onChangeFile
}: ContractUploadSectionProps) {
  if (fields.length === 0) return null;

  return (
    <Box
      data-app-id="journey-contract-step2-uploads-section"
      sx={{ display: 'flex', flexDirection: 'column', gap: 2, width: '100%' }}
    >
      <Typography data-app-id="journey-contract-step2-uploads-title" variant="h4">
        Fotos do equipamento
      </Typography>
      <Alert
        data-app-id="journey-contract-step2-uploads-alert"
        severity="warning"
        // Fundo amarelo claro nos dois temas: texto e ícone escuros fixos (no dark, text.primary é branco).
        sx={{ bgcolor: 'warning.light', color: neutral[1100], '& .MuiAlert-icon': { color: neutral[1100] } }}
      >
        *Atenção: as fotos devem ser nítidas, caso contrário, o seu pedido pode ser negado.
      </Alert>
      {showVoucherHint && voucher ? (
        <Typography data-app-id="journey-contract-step2-voucher-hint" variant="body2">
          <Typography component="span" fontWeight={700}>
            IMPORTANTE:{' '}
          </Typography>
          O voucher{' '}
          <Typography component="span" fontWeight={700}>
            {voucher}
          </Typography>{' '}
          é necessário enviar junto à foto da visão geral escrito em um papel fixado no equipamento.
        </Typography>
      ) : null}
      <Grid container spacing={3}>
        {fields.map((field) => (
          <Grid item key={field.key} md={field.fullWidth ? 12 : 6} xs={12}>
            <ContractJourneyFileUpload
              appId={contractUploadAppId(field.key)}
              error={errors[field.key]}
              label={field.label}
              onChangeFile={(file) => onChangeFile(field.key, file)}
              showSerialHelp={field.showSerialHelp}
            />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}
